import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import CourseDetail from "./pages/CourseDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import RichiediInfo from "./pages/RichiediInfo";
import ChatBot from "./components/ChatBot";
import WhatsAppButton from "./components/WhatsAppButton";

function ScrollToTop() {
  const { pathname } = window.location;
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/corsi/:slug" element={<CourseDetail />} />
          <Route path="/chi-siamo" element={<About />} />
          <Route path="/contatti" element={<Contact />} />
          <Route path="/richiedi-info" element={<RichiediInfo />} />
          <Route path="/iscrizione" element={<RichiediInfo />} />
        </Routes>
        <Footer />
        <Toaster />
        <ChatBot />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
